import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardGridModule } from '../components/card-grid/card-grid.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { CommonsLibModule } from 'commons-lib';
import { ReactiveFormsModule } from '@angular/forms';

import { BrokerModalEditionComponent } from '../broker-modal-edition/broker-modal-edition.component';
import { InputTextModule } from 'src/app/shared/components/input-text/input-text.module';
import { DropdownSelectModule } from 'src/app/shared/components/dropdown-select/dropdown-select.module';
import { InputDropdownCountryPrefixPhoneModule } from 'src/app/shared/components/input-dropdown-country-prefix-phone/input-dropdown-country-prefix-phone.module';

@NgModule({
  imports: [
    CommonModule,
    CardGridModule,
    NgZorroAntdModule,
    CommonsLibModule,
    InputTextModule,
    ReactiveFormsModule,
    InputDropdownCountryPrefixPhoneModule
  ],
  declarations: [BrokerModalEditionComponent],
  exports: [BrokerModalEditionComponent]
})
export class BrokerModalEditionModule {}
